import SelectInput, {SelectInputProps} from '@/components/refinedev/SelectInput';
import {TaskStatuses} from '../types';

// Danh sách trạng thái mặc định
export const StatusSelectInput = (
  props: Pick<SelectInputProps, 'source'> & Partial<SelectInputProps>,
) => {
  const {
    source,
    label = 'Trạng thái',
    placeholder = 'Chọn trạng thái',
    emptyOptionText = 'Chọn trạng thái',    
    ...rest
  } = props;
  
  return (
    <SelectInput
      source={source}
      choices={TaskStatuses} // Danh sách trạng thái cố định
      optionText="label"
      optionValue="id"
      label={label}
      placeholder={placeholder}
      emptyOptionText={emptyOptionText}
      {...rest}
    />
  );
};
